import { Sparkles, Users, LayoutPanelLeft, LineChart, ShieldCheck, Cloud, Check } from "lucide-react";

const ICONS = {
  sparkles: Sparkles,
  users: Users,
  "layout-panel-left": LayoutPanelLeft,
  "line-chart": LineChart,
  "shield-check": ShieldCheck,
  cloud: Cloud,
};

export default function ServiceCard({ service }) {
  const Icon = ICONS[service.icon] || Sparkles;
  return (
    <div
      className="glass hover-lift group relative flex h-full flex-col overflow-hidden rounded-3xl"
      data-testid={`service-card-${service.id}`}
    >
      {/* Clipped image with cohesive blue-duotone treatment */}
      {service.img && (
        <div className="relative h-44 w-full overflow-hidden md:h-52">
          <img
            src={service.img}
            alt={service.title}
            loading="lazy"
            className="img-tech h-full w-full object-cover group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-transparent to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-white/75 via-transparent to-transparent" />

          <div className="absolute left-6 top-6 flex items-center justify-center rounded-2xl chrome-orb" style={{ height: "3.25rem", width: "3.25rem" }}>
            <Icon size={22} strokeWidth={1.8} className="text-white" />
          </div>
          <span className="absolute right-6 top-7 rounded-full bg-black/35 px-2.5 py-1 font-mono-x text-[10px] uppercase tracking-[0.18em] text-white backdrop-blur">
            {service.tag}
          </span>
        </div>
      )}

      <div className="flex flex-1 flex-col p-8 pt-6">
        <h3 className="font-display text-2xl font-bold tracking-tight text-slate-900">
          {service.title}
        </h3>
        <p className="mt-3 flex-1 text-base leading-relaxed text-slate-600">
          {service.desc}
        </p>

        <ul className="mt-6 flex flex-wrap gap-2">
          {service.points.map((p) => (
            <li
              key={p}
              className="inline-flex items-center gap-1.5 rounded-full border border-slate-900/10 bg-slate-900/[0.04] px-3 py-1.5 text-xs text-slate-700"
            >
              <Check size={12} className="text-blue-600" />
              {p}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
